<template>
  <input
    :id="id"
    v-model="model"
    class="cat-input"
    :placeholder="placeholder"
    type="number"
    :min="min"
    :max="max"
    :aria-invalid="errors"
    :aria-required="mandatory"
    :required="errors"
    :title="label"
    :aria-label="label"
    :data-label="label"
    @change="_onChange"
    @input="_onInput"
    @blur="_onBlur"
    @scroll="wheel"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatNumber",
  props: {
    placeholder: [String],
    mandatory: [Boolean, String],
    id: [String, Number],
    label: [String],
    value: [String, Number],
    errors: [Boolean],
    readonly: [Boolean],
    min: [Number, String],
    max: [Number, String]
  },
  data: function () {
    return {
      model: this.value
    };
  },
  watch: {
    value: function (newvalue) {
      if (newvalue != this.model) {
        this.model = newvalue;
      }
    }
  },
  methods: {
    _onChange: function (event) {
      this.$emit("ui-change", {
        event: event,
        value: this.model,
        id: this.id ? this.id : null
      });
    },
    _onBlur: function (event) {
      this.$emit("ui-blur", {
        event: event,
        value: this.model,
        id: this.id ? this.id : null
      });
    },
    _onInput: function (event) {
      this.model = event.target.value; //two way binding
      this.$emit("ui-input", {
        event: event,
        value: this.model,
        id: this.id ? this.id : null
      });
    },
    wheel: function (event) {
      console.log(event);
    }
  }
});
</script>
